import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "format-key": "0" }
const _hoisted_2 = { class: "_whs-nw" }
const _hoisted_3 = {
  key: 0,
  class: "_td-lt"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_display_currency_value = _resolveComponent("display-currency-value")

  return (_openBlock(), _createBlock(_component_display_currency_value, {
    tag: $props.tag,
    "reverse-tooltip-position": $props.reverseTooltipPosition
  }, _createSlots({
    content: _withCtx(({ displayCurrency }) => [
      _renderSlot(_ctx.$slots, "effective-price", {
        effectivePrice: $options.getFormattedPrice($props.effectivePrice / displayCurrency.relativeFactorWithCommission, displayCurrency.symbol)
      })
    ]),
    tooltip: _withCtx(() => [
      _renderSlot(_ctx.$slots, "tooltip")
    ]),
    "tooltip-content": _withCtx(() => [
      _createElementVNode("span", null, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.ProjectApproximateCurrencyConversionTooltip
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString($options.formattedEffectivePrice), 1 /* TEXT */),
              ($props.isDiscounted)
                ? (_openBlock(), _createElementBlock("s", _hoisted_3, _toDisplayString($options.formattedPrice), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "effective-price", { effectivePrice: $options.formattedEffectivePrice }),
      ($props.isDiscounted)
        ? _renderSlot(_ctx.$slots, "price", {
            key: 0,
            price: $options.formattedPrice
          })
        : _createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ($props.isDiscounted)
      ? {
          name: "content-alt",
          fn: _withCtx(({ displayCurrency }) => [
            _renderSlot(_ctx.$slots, "price", {
              price: $options.getFormattedPrice($props.price / displayCurrency.relativeFactorWithCommission, displayCurrency.symbol)
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["tag", "reverse-tooltip-position"]))
}